<template>
  <v-app>
    <loading-effect />
    <loading-effect2 />
    <div v-if="isLogedIn && !drawer" class="px-1 menu-anker--link d-none d-md-block">
      <a @click="drawer=!drawer">
        <v-icon small color="#FFFFFF" style="padding-top: 7px;">mdi-forwardburger</v-icon>
      </a>
    </div>
    <div v-if="isLogedIn && !drawer" class="px-1 menu-anker--link-md block-sm-and-down hidden-md-and-up">
      <a @click="drawer=!drawer">
        <v-icon large color="#FFFFFF" style="padding-top: 3px;">mdi-forwardburger</v-icon>
      </a>
    </div>
    <v-navigation-drawer
      v-if="isLogedIn"
      app
      v-model="drawer"
      style="background: #EEF5F9 0% 0% no-repeat padding-box;box-shadow: 0px 3px 5px;opacity: 1;"
      clipped
      width="200">

      <v-container fluid>
        <div class="block-sm-and-down hidden-md-and-up" style="height:58px" />
        <div class="py-1" style="padding-left: 10px !important;">
          <v-switch v-model="isFullMenu" class="small-switch" inset dense @change="onSwitchChange">
            <template #label>
              <span :style="{ color: isFullMenu ? 'primary' : 'secondary' }">
                全機能表示
              </span>
            </template>
          </v-switch>
          <a @click="drawer=!drawer">
            <div class="d-none d-md-block">
              <v-icon small style="padding-top:2px" color="primary">mdi-backburger</v-icon>
              <span class="v-menu-close-text">メニューを閉じる</span>
            </div>
            <div class="block-sm-and-down hidden-md-and-up">
              <v-icon style="padding-top:2px" color="primary">mdi-backburger</v-icon>
              <span class="v-menu-close-text">メニューを閉じる</span>
            </div>
          </a>
        </div>
        <div class="py-1" style="padding-left: 10px !important;">
          <a @click="onHomeButtonClick">
            <div class="d-none d-md-block">
              <v-icon small style="padding-top:2px" color="primary">mdi-home-outline</v-icon>
              <span class="v-menu-close-text">トップページ</span>
            </div>
            <div class="block-sm-and-down hidden-md-and-up">
              <v-icon style="padding-top:2px" color="primary">mdi-home-outline</v-icon>
              <span class="v-menu-close-text">トップページ</span>
            </div>
          </a>
        </div>

        <!-- 通常メニュー -->
        <v-list class="py-0" dense  v-if="isFullMenu">

          <v-list-group class="pl-2" v-for="menu in menuList" :key="menu.id" no-action :append-icon="menu.lists ? undefined : ''">
            <template v-slot:prepend-icon />
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>
                  <div class="d-none d-md-block">
                    <v-icon small color="#2d71bf">{{ menu.icon }}</v-icon>
                    <span class="v-menu-group-name">{{ menu.menuNm }}</span>
                  </div>
                  <div class="block-sm-and-down hidden-md-and-up">
                    <v-icon color="#2d71bf">{{ menu.icon }}</v-icon>
                    <span class="v-menu-group-name-md">{{ menu.menuNm }}</span>
                  </div>
                </v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item v-for="sub in menu.lists" :key="sub.id">
              <v-list-item-content>
                <v-list-item-title>
                  <router-link v-if="['prm-haishameisai-edit', 'prm-nippo-easyedit', 'prm-nippo-edit'].some(target => sub.viewNm.startsWith(target))" @click.native="onRoute()" :to="{ name: sub.viewNm, params: { id: [0, '0'] }}">{{ sub.kinoTitle }}</router-link>
                  <router-link v-else @click.native="onRoute()" :to="{ name: sub.viewNm, params: { id: 0 }}">{{ sub.kinoTitle }}</router-link>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>

        </v-list>

        <!-- 簡易メニュー -->
        <v-list class="py-0" dense v-else>
          <div v-for="menu in menuList" :key="menu.id">
            <div v-if="menu.oftenUseFlg">
              <div v-if="[7, 20].includes(menu.id)">
                <!-- マスタのみグループ表示 -->
                <v-list-group class="pl-2">
                  <template v-slot:prepend-icon />
                  <template v-slot:activator>
                    <v-list-item-content>
                      <v-list-item-title>
                        <div class="d-none d-md-block">
                          <v-icon small color="#2d71bf">{{ menu.icon }}</v-icon>
                          <span class="v-menu-group-name">{{ menu.menuNm }}</span>
                        </div>
                        <div class="block-sm-and-down hidden-md-and-up">
                          <v-icon color="#2d71bf">{{ menu.icon }}</v-icon>
                          <span class="v-menu-group-name-md">{{ menu.menuNm }}</span>
                        </div>
                      </v-list-item-title>
                    </v-list-item-content>
                  </template>
                  <v-list-item v-for="sub in menu.lists" :key="sub.id">
                    <v-list-item-content v-if="sub.oftenUseFlg" class="often-menu-item-1">
                      <v-list-item-title>
                        <router-link v-if="['prm-haishameisai-edit', 'prm-nippo-easyedit', 'prm-nippo-edit'].includes(sub.viewNm)" @click.native="onRoute()" :to="{ name: sub.viewNm, params: { id: [0, '0'] }}">{{ sub.kinoTitle }}</router-link>
                        <router-link v-else @click.native="onRoute()" :to="{ name: sub.viewNm, params: { id: 0 }}">{{ sub.kinoTitle }}</router-link>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-group>
              </div>
              <div v-else>
                <v-list-item v-for="sub in menu.lists" :key="sub.id">
                  <v-list-item-content v-if="sub.oftenUseFlg" class="often-menu-item-2">
                    <v-list-item-title>
                      <v-icon small color="#2d71bf">{{ menu.icon }}</v-icon>
                      <router-link v-if="['prm-haishameisai-edit', 'prm-nippo-easyedit', 'prm-nippo-edit'].includes(sub.viewNm)" @click.native="onRoute()" :to="{ name: sub.viewNm, params: { id: [0, '0'] }}">{{ sub.kinoTitle }}</router-link>
                      <router-link v-else @click.native="onRoute()" :to="{ name: sub.viewNm, params: { id: 0 }}">{{ sub.kinoTitle }}</router-link>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </div>
            </div>
          </div>
        </v-list>

      </v-container>
    </v-navigation-drawer>

    <v-app-bar
      v-if="isLogedIn"
      app
      elevation="2"
      color="maintitle"
      dark
      dense
      clipped-left
      clipped-right
      height="58px"
      v-resize="onResize"
      @resize="onResize"
      style="z-index:15"
      id="_header">

      <v-container class="pa-0 ma-0" fluid>

        <v-row no-gutters align-content="center">

          <v-col :cols=5>
            <v-toolbar color="maintitle" flat dense>

              <!-- 体裁調整用 -->
              <span class="ml-1"></span>

              <template>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn text
                      v-bind="attrs"
                      v-on="on"
                      class="ma-0"
                      width="140"
                      color="black"
                      style="padding-left: 0px;padding-right: 0px;"
                      @click="onHomeButtonClick"
                    >
                    <v-img src="@/assets/ddlogo.png" max-width="140" max-height="30" contain></v-img>
                    </v-btn>
                  </template>
                  <!-- RAW形式で文字列展開 -->
                  <span>トップページに遷移します</span>
                </v-tooltip>
              </template>
            </v-toolbar>
          </v-col>

          <v-col :cols=2 />

          <v-col :cols=5>
            <v-toolbar color="maintitle" flat dense>
              <v-spacer/>
              <template>
                <v-menu
                  bottom
                  open-on-hover
                  transition="slide-y-transition"
                  :close-on-content-click="false"
                  :offset-y="offset"
                  style="z-index:15"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on">
                      <v-btn v-bind="attrs" v-on="on" fab small color="primary" class="mt-1">
                        <v-badge
                          color="green"
                          :content="notificationCount"
                          :value="notificationCount !== null && notificationCount !== 0"
                          overlap
                          offset-x="5"
                          offset-y="10"
                          right
                          style="z-index: 10 !important;"
                        >
                            <v-icon>mdi-bell-ring-outline</v-icon>
                            <!-- 通知なしの時 -->
                            <!-- mdi-bell-outline -->
                        </v-badge>
                      </v-btn>
                      <p class="top-bar-function">通知</p>
                    </div>
                  </template>
                  <v-list rounded dense v-if="notificationCount > 0">
                    <v-list-item v-if="adminNotificationCount > 0">
                      <v-list-item-content>
                        <v-list-item-title>管理者からのお知らせが <a @click="sendToAdminNotification" class="notification-link">{{adminNotificationCount}}</a> 件あります</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item v-if="systemNotificationCount > 0">
                      <v-list-item-content>
                        <v-list-item-title>システムからのお知らせが <a @click="sendToSystemNotification" class="notification-link">{{systemNotificationCount}}</a> 件あります</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item v-if="carNotificationCount > 0">
                      <v-list-item-content>
                        <v-list-item-title>車両のお知らせが <a @click="sendToCarNotification" class="notification-link">{{carNotificationCount}}</a> 件あります</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item v-if="licenceNotificationCount > 0">
                      <v-list-item-content>
                        <v-list-item-title>免許更新のお知らせが <a @click="sendToLicenceNotification" class="notification-link">{{licenceNotificationCount}}</a> 件あります</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </template>

              <!-- 体裁調整用 --

              <span class="ma-1"></span>

              <div>
                <v-btn fab small color="primary" class="mt-4" @click="onHelpButtonClick">
                    <v-icon>mdi-help-circle-outline</v-icon>
                </v-btn>
                <p class="top-bar-function">ヘルプ</p>

              </div>
              -->
              <!-- 体裁調整用 -->
              <span class="ma-1"></span>

              <template>
                <v-menu
                  bottom
                  open-on-hover
                  transition="slide-y-transition"
                  :close-on-content-click="false"
                  :offset-y="offset"
                  style="z-index:15"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on">
                      <v-btn v-bind="attrs" v-on="on" fab small color="primary" class="mt-1">
                        <div v-if="dispUserImage">
                          <v-avatar size="38">
                            <v-img :src="userImage"/>
                          </v-avatar>
                        </div>
                        <div v-else>
                          <v-icon>mdi-account-circle</v-icon>
                        </div>
                      </v-btn>
                      <p class="top-bar-function">{{ userName }}</p>
                    </div>
                  </template>
                  <v-list rounded dense>
                    <v-list-item v-for="(item, index) in user_menu_list" :key="index" @click="selectUserMenuItem(item.event)">
                      <v-list-item-icon>
                        <v-icon v-text="item.icon"></v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title v-text="item.title"></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </template>

              <!-- 体裁調整用 -->
              <span class="ma-1"></span>

              <template>
                <v-menu
                  bottom
                  open-on-hover
                  transition="slide-y-transition"
                  :close-on-content-click="false"
                  :offset-y="offset"
                  style="z-index:15"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on">
                      <v-btn v-bind="attrs" v-on="on" fab small color="primary" class="mt-1">
                        <v-icon color="white">mdi-view-grid-outline</v-icon>
                      </v-btn>
                      <p class="top-bar-function">メニュー</p>
                    </div>
                  </template>
                  <v-list rounded dense>
                    <v-list-item v-for="(item, index) in app_menu_list" :key="index" @click="selectUserMenuItem(item.event)">
                      <v-list-item-icon>
                        <v-icon v-text="item.icon"></v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title v-text="item.title"></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </template>
            </v-toolbar>
          </v-col>
        </v-row>
      </v-container>
    </v-app-bar>
    <div v-else style="height:0px" id="_header" />

    <v-main style="background-color:#D0DFE4;">
      <v-container fluid v-resize="onResize" @resize="onResize">
        <div id="page-top" class="page-top bg-image" />
        <router-view v-mutate="onMutate"/>
      </v-container>
    </v-main>

    <dd-password-edit-dialog
      :showDialog="showPasswordEditFlg"
      @save="onSavePasswordEditDialogClick()"
      @close="onClosePasswordEditDialogClick()"
    />

    <dd-function-list-dialog
      :showDialog="showFunctionDialogFlg"
      @cancelClose="onCloseFunctionDialogClick(false)"
      @close="onCloseFunctionDialogClick(true)"/>

    <dd-user-settings-dialog
      :showDialog="showUserSettingDialogFlg"
      @save="onSaveUserSettingDialogClick()"
      @close="onCloseUserSettingDialogClick()"
    />
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'
import LoadingEffect from '@/components/LoadingEffect'
import LoadingEffect2 from '@/components/LoadingEffect2'
import viewMixins from '@/mixins/viewMixins'
import DdFunctionListDialog from '@/components/DdFunctionListDialog'
import DdPasswordEditDialog from '@/components/DdPasswordEditDialog'
import DdUserSettingsDialog from '@/components/DdUserSettingsDialog'
import modals from '@/ddv2.library/modals'
import Cookies from 'js-cookie'

export default {
  name: 'App',
  mixins: [viewMixins],
  components: {
    LoadingEffect,
    LoadingEffect2,
    DdFunctionListDialog,
    DdPasswordEditDialog,
    DdUserSettingsDialog
  },

  computed: {
    ...mapGetters({
      isLogedIn: 'users/isLogedIn',
      userId: 'users/userId',
      userName: 'users/userName',
      userImage: 'DDMasters/image',
      menuList: 'DDMasters/menuList',
      viewTitle: 'system/viewTitle',
      summaryMessage: 'system/summaryMessage',
      messageKbn: 'system/messageIcon',
      expandBanner: 'system/expandBanner',
      msyssystemconfig: 'DDMasters/msysSystemConfig',
      // お知らせ件数
      notificationCount: 'system/notificationCount',
      adminNotificationCount: 'system/adminNotificationCount',
      systemNotificationCount: 'system/systemNotificationCount',
      carNotificationCount: 'system/carNotificationCount',
      licenceNotificationCount: 'system/licenceNotificationCount'
    }),
    messageIcon: function () {
      if (this.messageKbn === 'C') { return 'mdi-alert-outline' }
      if (this.messageKbn === 'I') { return 'mdi-information-outline' }
      if (this.messageKbn === 'E') { return 'mdi-close-circle-outline' }
      return ''
    },
    messageIconColor: function () {
      if (this.messageKbn === 'C') { return 'warning' }
      if (this.messageKbn === 'I') { return 'blue' }
      if (this.messageKbn === 'E') { return 'red' }
      return 'black'
    },
    dispUserImage: function () {
      if (this.userImage === undefined || this.userImage === '' || this.userImage === null) {
        return false
      }
      return true
    }
  },
  mounted: function () {
    console.log('App.Mounted', this)

    this.isFullMenu = Cookies.get('ddMenuType') === undefined || Cookies.get('ddMenuType') === 'true'

    let queue = null
    const wait = 500
    const self = this
    window.addEventListener('resize', function () {
      clearTimeout(queue)
      queue = setTimeout(function () {
        self.onResize()
      }, wait)
    }, false)

    // 初回のみ強制リロード
    const hasReloaded = sessionStorage.getItem('hasReloaded')
    if (!hasReloaded) {
      sessionStorage.setItem('hasReloaded', 'true')
      window.location.reload()
    }
  },
  data: () => ({
    drawer: true,
    systemtitle: 'DriveDoor',
    user_menu_list: [
      { title: 'ログアウト', icon: 'mdi-exit-run', message: '現在の作業を終了しログアウトします', event: 'LOGOUT' },
      { title: 'パスワード変更', icon: 'mdi-account-edit', message: 'ログイン中ユーザのパスワード編集画面を起動します。', event: 'USEREDIT' },
      { title: '個別設定', icon: 'mdi-cogs', message: '表示したい項目や使用する画面の設定を行います', event: 'USERSETTINGS' }
    ],
    app_menu_list: [
      { title: 'トップページ', icon: 'mdi-home', message: 'トップメニューに遷移します', event: 'TOP' },
      // { title: 'ログアウト', icon: 'mdi-logout', message: '現在の作業を終了しログアウトします', event: 'LOGOUT' },
      // { title: 'パスワード変更', icon: 'mdi-account-edit', message: 'ログイン中ユーザのパスワード編集画面を起動します。', event: 'USEREDIT' },
      { title: '機能一覧', icon: 'mdi-view-grid-outline', message: '使用できる全機能をポップアップ表示します', event: 'FUNCLIST' },
      { title: 'マスタデータ更新', icon: 'mdi-database-sync', message: 'マスタデータを更新します', event: 'DBSYNC' }
      // { title: '予定表', icon: 'mdi-calendar-edit', message: '予定表を表示します', event: 'SCHEDULER' },
      // { title: 'アプリケーション更新', icon: 'mdi-cloud-refresh', message: 'アプリケーションを更新します', event: 'APSYNC' }
      // { title: 'ヘルプ', icon: 'mdi-help-circle', message: 'ヘルプを表示します', event: 'HELP' }
    ],
    isFullMenu: true,
    offset: true,
    hover: false,
    selectedUserMenuItem: '',
    showFunctionDialogFlg: false,
    showPasswordEditFlg: false,
    showUserSettingDialogFlg: false
  }),
  watch: {
    expandBanner: function (o, n) {
      if (o === n) { return }
      this.onResize()
    }
  },
  methods: {
    onMessageExpandButtonClick: function () {
      this.$store.dispatch('system/toggleSummaryMessage')
    },
    onMutate: function (e) {
      this.onResize(e)
    },
    onResize: function (e) {
      console.log('App.vue resize event')

      // イベント発火から、DOMの更新が終わるまで待機
      this.$nextTick(function () {
        const headerHeight = document.getElementById('_header').scrollHeight
        var messageHeight = 0
        const resizeParam = {
          headerHeight,
          messageHeight
        }
        // グローバルイベントとして発行
        this.$router.app.$emit('element-resize', resizeParam)
      })
    },
    onRoute: function (e) {
      this.showFunctionDialogFlg = false
      this.$store.dispatch('system/clearMessage')
    },
    onHomeButtonClick: function () {
      // SummaryMessage初期化
      this.clearSummaryMessage()
      // InvalidMessage初期化
      this.clearInvalidMessage(this.$refs)
      // スタートページ取得
      const startPage = this.getDefaultStartPage()
      // 画面遷移
      var path = location.href
      path = path.substring(0, path.indexOf('#/'))
      window.location.href = path + startPage
    },
    onUserEditClick: function () {
      // SummaryMessage初期化
      this.clearSummaryMessage()
      // InvalidMessage初期化
      this.clearInvalidMessage(this.$refs)
      this.showPasswordEditFlg = true
    },
    onSavePasswordEditDialogClick: function () {
      modals.showToastMessage('COMI0002', null, 500, null, 'info')
      this.showPasswordEditFlg = false
    },
    onClosePasswordEditDialogClick: function () {
      this.showPasswordEditFlg = false
    },
    onShowFunctionDialogClick: function () {
      this.showFunctionDialogFlg = true
    },
    onCloseFunctionDialogClick: function (drawerFlg) {
      this.showFunctionDialogFlg = false
    },
    onShowUserSettingDialogClick: function () {
      this.showUserSettingDialogFlg = true
    },
    onCloseUserSettingDialogClick: function () {
      this.showUserSettingDialogFlg = false
    },
    onSaveUserSettingDialogClick: function () {
      this.showUserSettingDialogFlg = false
      this.Effects.loadStart()
      window.location.reload().then(() => {
        this.Effects.loadComplete()
      })
    },
    onRefreshButtonClick: function () {
      window.location.reload(true)
    },
    onLogoutButtonClick: function () {
      // 権限エラー初期化
      this.HttpClient.clearError()

      const p = modals.showConfirmYesNo
      p('COMQ0009').then((ok) => {
        if (ok === false || ok === undefined) { return }
        // SummaryMessage初期化
        this.clearSummaryMessage()

        const initialValue = {
          authjwttoken: '',
          mstfaseimage: {},
          mstkengen: [],
          mstkengengroup: {},
          msysgamenseni: [],
          msyskino: [],
          msysmenu: [],
          msysmenudetail: [],
          msysmenuoshirase: [],
          msysinputsave: [],
          msysmessage: [],
          msystax: [],
          vwcmstkengengroup: []
        }

        this.$router.push('about:blank').then(() => {
          this.Effects.loadStart()
          this.$nextTick().then(() => {
            this.$store.dispatch('DDMasters/saveMasters', initialValue).then(() => {
              this.$router.replace('/').then(() => {
                this.Effects.loadComplete()
              })
            })
          })
        })
      })
    },
    onHelpButtonClick: function () {
      const url = this.filterExLink5URL()
      window.open(url, '_blank')
    },
    onDbSyncButtonCleck: function () {
      const p = modals.showConfirm
      p('COMQ0010').then((ok) => {
        if (ok === false || ok === undefined) { return }

        this.Effects.loadStart()

        const dblist = [
          'msystax',
          'vwcmsttorihikisakigetnyukinsaki',
          'vwcmsttorihikisakigetshiharaisaki',
          'vwcmsttorihikisakigetseikyusaki',
          // 'vwcmstkengengroup01',
          'mstjinin',
          'mstmenkyosho',
          'mstjishaginkokoza',
          'msttorihikisaki',
          'msteigyosho',
          'msyskubun',
          'msyskubunshubetsushurui',
          'msthacchakuchi',
          'mstshubetsu',
          'mstkihonjoho',
          'mstkingaku',
          'msthinmei',
          'mstsharyo',
          // 'msysmessage',
          // 'mstfaceimage',    // 2021.10 容量過多かつ最新保持の必要はないためコメントアウト
          // 'mstkengen',
          // 'mstkengengroup',  // 2021.10 原因不明のエラー発生<TypeError: state[c].map is not a function>
          // 'msysgamenseni',
          // 'msyskino',
          // 'msysmenu',
          // 'msysmenudetail',
          // 'msysmenuoshirase',
          // 'msysinputsave',
          // 'msyssystemconfig',
          'msttokuisaki',
          'mstnyukinsaki',
          'msthacchusaki',
          'mstseikyusaki',
          'mstshiharaisaki',
          'mstaddress',
          'mstshuhaichiku',
          // 'vwcmstchimei',  // 2021.10 ryukyu_devのみ実装されているためコメントアウト
          'mstbumon',
          'mstfileformatkihon',
          'vwcmsteigyoshojininlist',
          'vwcmstsharyo',
          // 'vwcmstkengengroup',
          // 'vwcd2mstd0370' // 2023.01 awa版定型コースのためコメントアウト
          'vwcd2mstd0460',
          'mstnenpicategory',
          'mstxlsimportmapping',
          'msthaishahyo'
        ]

        this.$store.dispatch('DDMasters/truncateMasters', { list: dblist }).then(() => {
          this.$store.dispatch('DDMasters/loadMasters', { list: dblist, version: 1, kinoId: 0 }).then(() => {
            modals.showToastMessage('COMI0005', null, 500, null, 'info')
            this.Effects.loadComplete()
          })
        })
      })
    },
    onSchedulerClick: function () {
      // SummaryMessage初期化
      this.clearSummaryMessage()
      // InvalidMessage初期化
      this.clearInvalidMessage(this.$refs)
      var path = location.href
      path = path.substring(0, path.indexOf('#/'))
      window.location.href = path + '#/ddcalendar'
    },
    // ユーザーメニュー選択イベント
    selectUserMenuItem: function (event) {
      if (event === 'TOP') {
        this.onHomeButtonClick()
      } else if (event === 'LOGOUT') {
        this.onLogoutButtonClick()
      } else if (event === 'APSYNC') {
        this.onRefreshButtonClick()
      } else if (event === 'USEREDIT') {
        this.onUserEditClick()
      } else if (event === 'USERSETTINGS') {
        this.onShowUserSettingDialogClick()
      } else if (event === 'HELP') {
        this.onHelpButtonClick()
      } else if (event === 'DBSYNC') {
        this.onDbSyncButtonCleck()
      } else if (event === 'FUNCLIST') {
        this.onShowFunctionDialogClick()
      } else if (event === 'SCHEDULER') {
        this.onSchedulerClick()
      } else {
        // 何もしない
      }
    },
    /*
     * ヘルプリンク
     */
    filterExLink5URL: function () {
      const self = this
      const ret = self.msyssystemconfig.filter(function (elem) {
        return elem.configName === 'external_link_5' && elem.delFlg === false
      })
      if (ret.length !== 0) {
        return ret[0].configValue1
      }
      return ''
    },
    /**
     * お知らせ移動
     */
    sendToAdminNotification: function () {
      this.controlScrollPosition('.admin-notification', 0)
    },
    sendToSystemNotification: function () {
      this.controlScrollPosition('.system-notification', 0)
    },
    sendToCarNotification: function () {
      this.controlScrollPosition('.car-notification', 0)
    },
    sendToLicenceNotification: function () {
      this.controlScrollPosition('.licence-notification', 0)
    },
    getDefaultStartPage: function () {
      let startPage = '#/ddboard'
      const ret = this.msyssystemconfig.filter(function (elem) {
        return elem.configName === 'default_start_page'
      })
      if (ret.length > 0 && ret[0].configValue1 !== '') {
        startPage = '#/' + ret[0].configValue1
      }
      return startPage
    },
    onSwitchChange: function (value) {
      // クッキーに保存（Boolean → String）
      Cookies.set('ddMenuType', value, { expires: 7 })
    }
  }
}

</script>
<style src="./App.css" />
<style scope>
.notification-link {
    cursor: pointer;
    cursor: hand;
    position: relative;
    font-size: medium !important;
    color: blue !important;
    text-decoration: none !important;
}
.notification-link:hover {
    font-weight: bold;
}
.small-switch {
  transform: scale(0.85); /* 例: 75%の大きさに */
  transform-origin: left center;
}
.often-menu {
  padding-left: 10px !important;
  padding-top: 7px !important;
  padding-bottom: 1px !important;
}
.often-menu-item-1 {
  padding-left: 30px !important;
}
.often-menu-item-2 {
  padding-left: 8px !important;
}
</style>
